module.exports = __webpack_public_path__ + "img/log_card_icon.50f78fc5.svg";